import { connect } from 'react-redux';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import CreateProspectsContainer from './containers/CreateProspect/CreateProspect';
import withFormLayout from './containers/FormLayout/FormLayout';
import AssessmentContainer from './containers/Assessment/Assessment';
import withAssessmentLayout from './containers/AssessmentLayout/AssessmentLayout';
import ReportContainer from './containers/Report/Report';

import './App.css';

const CreateProspects = withFormLayout(CreateProspectsContainer);
const Assessment = withAssessmentLayout(AssessmentContainer);
const Report = withAssessmentLayout(ReportContainer);

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CreateProspects />} />
        <Route path="/questions" element={<Assessment showInstructions={true} />} />
        <Route path="/report" element={<Report />} />
      </Routes>
    </BrowserRouter>
  );
}

export default connect(null, {})(App);

